<div class="acesso-negado">
  <div class="acesso-negado__card">
    <div class="acesso-negado__icon">
      <span class="po-icon an an-lock"></span>
    </div>

    <h1 class="acesso-negado__title">Acesso negado</h1>

    <p class="acesso-negado__desc">
      Você não possui permissão para acessar este recurso. Caso acredite que isso é um engano,
      entre em contato com o administrador para revisar seus privilégios.
    </p>

    <div class="acesso-negado__actions">
      <po-button
        p-kind="primary"
        p-label="Voltar"
        p-icon="an an-arrow-left"
        (p-click)="voltar()">
      </po-button>
    </div>
  </div>
</div>
